import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getOr } from 'lodash/fp';
import { Button, ButtonGroup, Content, Icon } from 'rsuite';
import {
  deleteROItem,
  fetchROItemForView
} from '../../../../redux/Reservation/sagas/routines';
import { resetROItemView } from '../../../../redux/Reservation/actions/routes/ro-item/view';
import { getROItemViewData } from '../../../../redux/Reservation/selectors/routes/ro-item/view';
import { getIsDeleting } from '../../../../redux/Reservation/selectors/ro-item';
import {
  viewAccess,
  modifyAccess,
  fullAccess
} from '../../../../helpers/permission';
import * as PERMISSIONS from '../../../../constants/permissions/reservation';
import pagePathToUrl from '../../../../helpers/pagePathToUrl';
import {
  reservationsROItemEditPath,
  reservationsROItemListPath
} from '../../../Paths';
import history from '../../../history';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../components/reservations/PageLayout';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import ButtonToolbar from '../../../../components/reservations/ButtonToolbar';
import ItemDetails from './ItemDetails';
import Breadcrumb from '../../../../components/Breadcrumb';
import DeleteConfirmationModal from '../../../../components/DeleteConfirmationModal';

export default () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const item = useSelector(getROItemViewData);
  const isDeleting = useSelector(getIsDeleting);

  useEffect(
    () => {
      dispatch(fetchROItemForView(id));
      return function reset() {
        dispatch(resetROItemView());
      };
    },
    [id]
  );

  const handleEdit = () => {
    history.push(pagePathToUrl(reservationsROItemEditPath, { id }));
  };

  const handleShowDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const handleHideDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleConfirmDeleteItem = () => {
    setShowDeleteModal(false);
    dispatch(deleteROItem(item));
    setTimeout(() => {
      history.push(reservationsROItemListPath);
    }, 200);
  };

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={viewAccess(PERMISSIONS.RO_ITEM)}
        fallback={<AccessDenied />}
      >
        <Breadcrumb
          items={[
            {
              label: 'Items',
              path: reservationsROItemListPath
            },
            { label: getOr('...', 'name', item) }
          ]}
        />
        <PageHeader title="View Item" />
        <Content style={{ marginTop: 0 }}>
          <ButtonToolbar>
            <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.RO_ITEM)}>
              <ButtonGroup>
                <Button size="sm" appearance="primary" onClick={handleEdit}>
                  <Icon icon="pencil" /> Edit
                </Button>
              </ButtonGroup>
            </AccessControl>
            <AccessControl allowOnlyFor={fullAccess(PERMISSIONS.RO_ITEM)}>
              <ButtonGroup>
                <Button size="sm" onClick={handleShowDeleteModal} color="red">
                  <Icon icon="trash" /> Delete
                </Button>
              </ButtonGroup>
            </AccessControl>
          </ButtonToolbar>
          {item && <ItemDetails data={item} />}

          <DeleteConfirmationModal
            message="Warning: Deleting Item will also remove the Item from the Pick Lists. Are you sure you want to delete this Item?"
            show={showDeleteModal}
            onHide={handleHideDeleteModal}
            onConfirm={handleConfirmDeleteItem}
            isDeleting={isDeleting}
          />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
